import SSectionColumnController from '../parsers/s-section-column';
import type { SectionParams, SectionReturn } from '../types';

export default function (params: SectionParams): SectionReturn {
  const { cssFlags, background, gridColumns, columns, _uid, _editable } = params;

  return {
    module: 'SSection',
    _uid,
    _editable,
    gridColumns: parseInt(gridColumns, 10),
    cssFlags,
    background,
    columns: columns?.map((c) => SSectionColumnController(c))
  };
}
